<template>
  <div class="practicalActivity-list">
    <el-table ref="multipleTable" :data="practicalActivityList" tooltip-effect="dark" style="width: 100%"
      @selection-change="handleSelectionChange" class="common-edit-button">
      <el-table-column label="#" type="index"> </el-table-column>
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="activityName" label="活动名称" width="250px" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="活动时间" :show-overflow-tooltip="true" width="250px">
        <template slot-scope="scope">
          {{ scope.row.startTime }}-{{ scope.row.endTime }}
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="semester" label="学期" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{semesterOptions.find(item => item.dictValue == scope.row.semester).dictLabel}}
        </template>
      </el-table-column>
      <el-table-column prop="schoolYear" label="学年" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="操作" width="275px">
        <template slot-scope="scope">
          <div class="handle-container">
            <!-- 学分学时录入 -->
            <el-button type="success" icon="el-icon-upload" @click="enterClick(scope.row)"
              v-hasPermi="'sc:practicerecord:query'" size="small">录入
            </el-button>
            <!-- 修改 -->
            <el-button type="warning" icon="el-icon-edit" @click="editClick(scope.row)"
              v-hasPermi="'sc:practicalactivity:edit'" size="small">修改
            </el-button>
            <!-- 删除 -->
            <!-- 详情 -->
            <!-- <el-button
              type="success"
              icon="el-icon-info"
              :disabled="classInfo.currentClass.isCharge != 1"
              @click="detailClick(scope.row)"
            >
            </el-button> -->
            <el-button type="danger" icon="el-icon-delete" @click="deleteClick(scope.row)"
              v-hasPermi="'sc:practicalactivity:delete'" size="small">删除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <practicalActivityEdit :isEditPracticalActivityShow.sync="isEditPracticalActivityShow"
      v-show="isEditPracticalActivityShow" :practicalActivityData="practicalActivityData"
      :semesterOptions="semesterOptions" />
  </div>
</template>

<script>
import practicalActivityEdit from "../practicalActivity-edit/practicalActivityEdit.vue";
export default {
  components: {
    practicalActivityEdit,
  },
  data() {
    return {
      title: "",
      isEditPracticalActivityShow: false,
      practicalActivityData: null,
    };
  },
  inject: ["refresh"],
  props: {
    practicalActivityList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    semesterOptions: {
      type: Array,
    },
  },
  methods: {
    // 学分学时录入
    enterClick(item) {
      this.$router.push({
        path: "/activity-score-entry",
        query: {
          activityInfo: JSON.stringify(item),
        },
      });
    },
    handleSelectionChange(val) {
      // console.log(val);
      this.selectList = val;
      let list = [];
      this.selectList.forEach((item) => {
        list.push(item.id);
      });
      this.$emit("multipleDelete", list);
    },
    // detailClick(item) {
    //   this.get(this.$url.getMedalDetail + "/" + item.id).then((res) => {
    //     this.medalDetail = res.data;
    //     this.detailShow = true;
    //   });
    // },
    editClick(item) {
      this.practicalActivityData = item;
      this.isEditPracticalActivityShow = true;
    },
    // 点击删除
    deleteClick(item) {
      // console.log(item);
      this.$confirm("是否删除该活动?", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass: "confirm",
      })
        .then(() => {
          // 调用删除活动信息接口
          let list = [];
          list.push(item.id);
          this.delete(this.$url.delPracticalActivity + "/" + list)
            .then((res) => {
              // console.log(res);
              if (res.code == 200) {
                this.$message.success("删除成功");
                // 刷新列表
                this.refresh();
              }
            })
            .catch((err) => {
              // console.log(err);
              this.$message.error("删除失败，请稍后重试");
            });
        })
        .catch(() => { });
    },
  },
};
</script>

<style>
@import "./practicalActivityList.scss";
</style>
